import { useTranslate } from 'core/hooks/useTranslate';
import Button from '../../../../../atoms/Button/Button';
import React from 'react';

/**
 * ReorderBanner - Banner that appears when reordering modules/submodules
 * Shows a message and two action buttons (cancel/save)
 */

type ReorderBannerProps = {
  onCancel: () => void;
  onSave: () => void;
  isLoading?: boolean;
};

function ReorderBanner({ onCancel, onSave, isLoading = false }: ReorderBannerProps): JSX.Element {
  const { t } = useTranslate();

  return (
    <div className="reorder-banner">
      <div className="reorder-banner__content">
        <p className="reorder-banner__message">{t('organize-content:Reorder banner message')}</p>
        <div className="reorder-banner__actions">
          <Button
            variant="primary-ghost"
            onClick={onCancel}
            isDisabled={isLoading}
            size="sm"
            type="button"
            text={t('organize-content:Discard changes')}
          />
          <Button
            variant="primary"
            size="sm"
            onClick={onSave}
            isDisabled={isLoading}
            type="button"
            text={t('organize-content:Confirm changes')}
          />
        </div>
      </div>
    </div>
  );
}

export default ReorderBanner;
